import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function OwnerReports({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="blue-info-text">Showing Feedback report</h3>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24} className="divider">
                <p>1.</p>{" "}
                <p className="blue-info-text">
                  Open this report -{" "}
                  <span className="onclick-text">survey</span>
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>2.</p> <p className="blue-info-text">Open Customize</p>
              </Col>
              <Col span={24} className="divider">
                <p>3.</p>{" "}
                <p className="blue-info-text">Set the report for "last week"</p>
              </Col>
              <Col span={24} className="divider">
                <p>4.</p>{" "}
                <p className="blue-info-text">Set the report for "last week"</p>
              </Col>
              <Col span={24} className="divider">
                <p>5.</p>{" "}
                <p className="blue-info-text">
                  Set property to the property you are listing and update
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>6.</p> <p className="blue-info-text">Click on actions</p>
              </Col>
              <Col span={24} className="divider">
                <p>7.</p>{" "}
                <p className="blue-info-text">
                  Save the report layout of the report with the property name
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>8.</p> <p className="blue-info-text">select schedule</p>
              </Col>
              <Col span={24} className="divider">
                <p>9.</p>{" "}
                <p className="blue-info-text">
                  Title the report by the property name
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>10.</p>{" "}
                <p className="blue-info-text">
                  For saved report select the report you just created
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>11.</p>{" "}
                <p className="blue-info-text">
                  Enter your email address for the recipient
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>12.</p>{" "}
                <p className="blue-info-text">
                  Enter the property address as the subject
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>13.</p>{" "}
                <p className="blue-info-text">For start date select today</p>
              </Col>
              <Col span={24} className="divider">
                <p>14.</p>{" "}
                <p className="blue-info-text">
                  For frequency select weekly and save
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>15.</p>{" "}
                <p className="blue-info-text">
                  as this report comes to you forward to the property owner as
                  you see fit.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <h3 className="blue-info-text">Listing Interest Report</h3>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24} className="divider">
                <p>1.</p>{" "}
                <p className="blue-info-text">
                  Open this report -{" "}
                  <span className="onclick-text">Interest</span>
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>2.</p> <p className="blue-info-text">Open Customize</p>
              </Col>
              <Col span={24} className="divider">
                <p>3.</p>{" "}
                <p className="blue-info-text">Set the report for "last week"</p>
              </Col>
              <Col span={24} className="divider">
                <p>4.</p>{" "}
                <p className="blue-info-text">
                  Set property to the property you are listing and update
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>5.</p> <p className="blue-info-text">Click on actions</p>
              </Col>
              <Col span={24} className="divider">
                <p>6.</p>{" "}
                <p className="blue-info-text">
                  Save the report layout with the property name
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>7.</p> <p className="blue-info-text">Select schedule</p>
              </Col>
              <Col span={24} className="divider">
                <p>8.</p>{" "}
                <p className="blue-info-text">
                  Title the report by the property name
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>10.</p>{" "}
                <p className="blue-info-text">
                  For saved report select the report you just created with the
                  property address
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>11.</p>{" "}
                <p className="blue-info-text">
                  Enter your email address for the recipient as well as the
                  property owner.
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>12.</p>{" "}
                <p className="blue-info-text">
                  Enter the property address as the subject
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>13.</p>{" "}
                <p className="blue-info-text">
                  Paste this into the message "This report shows details on the
                  leads we have had for the past week on your property that is
                  listed. I am watching this closely as well and will update you
                  on progress. If you have any questions feel free to reach out
                  to me by replying to this email"
                </p>
              </Col>
              <Col span={24} className="divider">
                <p>14.</p>{" "}
                <p className="blue-info-text">For start date select today</p>
              </Col>
              <Col span={24} className="divider">
                <p>15.</p>{" "}
                <p className="blue-info-text">
                  For frequency select weekly and save (unless the property
                  owner needs daily updates)
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default OwnerReports;
